import { projectClient } from '../../client/client';
import * as ext from './zambda-ext';

export const zambda = {
  list: projectClient('/zambda').get,
  create: projectClient('/zambda').post,
  get: projectClient('/zambda/{id}').get,
  delete: projectClient('/zambda/{id}').delete,
  update: projectClient('/zambda/{id}').patch,
  execute: projectClient('/zambda/{id}/execute').post,
  executePublic: projectClient('/zambda/{id}/execute-public').post,
  s3Upload: projectClient('/zambda/{id}/s3-upload').post,
  logStream: {
    list: projectClient('/zambda/{id}/logStream').post,
    get: projectClient('/zambda/{id}/logStream/{logStreamName}').post,
    search: projectClient('/zambda/{id}/logStream/search').post,
  },
  ...ext,
};
